import { IBillingPriceListItemModel } from './customer-billing-price.model';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { PricePerTypes } from './price-per-type';
import { Injector } from '@angular/core';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { fiCurrencyName } from '@fi-app/customer-billing/customer-billing-components/currency-name.pipe';
import { CurrencyTypes } from '@fi-app/customer-billing/customer-billing-price/currency-type';

export class CustomerBillingPriceListData extends ListData<IBillingPriceListItemModel> {
    constructor(injector: Injector, deleteFunc: (ids) => IFiHttpPromise<any>) {
        super(injector, true);

        this.ChildProperty = 'ChildItems';

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: (data) => (data.ParentId ? undefined : FiStateNames.CustomerBilling.Price.Edit),
                    SrefParams: (data) =>
                        data.ParentId ? undefined : { Id: data.ArticleId, ModuleId: data.ModuleId ? data.ModuleId : 0 },
                }),
            ),
        );

        /*this.addSpanPlainHeader(this.appTextService.get('customer_billing.price_in_base_currency'),
            'Price', '', true);*/

        CurrencyTypes.forEach((currencyType) => {
            this.addSpanPlainHeader(
                fiCurrencyName(currencyType.Id, this.appTextService),
                '',
                '',
                false,
                (data: IBillingPriceListItemModel, property) => {
                    const priceValue = data.PriceValues.find((pv) => pv.CurrencyType == currencyType.Id);
                    return priceValue ? priceValue.Price.toFixed(2) : '';
                },
            );
        });

        this.addSpanPlainHeader(
            this.appTextService.get('customer_billing.charge_per'),
            'PricePer',
            '',
            true,
            (data, property) => {
                const pricePerTypeItem = PricePerTypes.find((typeItem) => typeItem.Id == data[property]);
                return pricePerTypeItem ? this.appTextService.get(pricePerTypeItem.TextId) : '-';
            },
        );

        this.deleteFunc = deleteFunc.bind(this);
    }
}
